<script setup lang="ts">
import { Popover, PopoverButton, PopoverOverlay, PopoverPanel } from '@headlessui/vue';
import MenuIcon from '@/icons/MenuIcon.vue';
import HeaderMenuItem from '@/layouts/main/header/components/HeaderMenuItem.vue';
import { Menu } from '@types';
import CloseIcon from '@/icons/CloseIcon.vue';

// Properties
defineProps<{
    menu: Menu[],
}>();
</script>

<template>
    <Popover>
        <PopoverButton
            class="relative z-10 p-2 text-gray-200 active:text-gray-100 focus-visible:outline-none"
            v-slot="{ open }"
        >
            <MenuIcon
                v-if="!open"
                class="block w-6 h-6 shrink-0"
            />
            <CloseIcon
                v-else
                class="block w-6 h-6 shrink-0"
            />
        </PopoverButton>

        <PopoverOverlay
            class="fixed inset-0 bg-gray-900/50"
        />

        <PopoverPanel
            class="fixed inset-x-0 top-0 p-8 pt-30 bg-gray-900 border border-orange-400/35 border-t-0 rounded-b-2xl pointer-events-none"
            v-slot="{ close }"
        >
            <div class="space-y-4 pointer-events-auto">
                <template v-for="(item, index) in menu" :key="item.id">
                    <HeaderMenuItem
                        :item="item"
                        block
                        @click="close"
                    />

                    <hr
                        class="w-6 mx-auto border-orange-400/35 last-of-type:hidden"
                    />
                </template>
            </div>
        </PopoverPanel>
    </Popover>
</template>

<style scoped>

</style>
